module.exports = __webpack_public_path__ + "3717d52ed97a2aa98193091a8063a4fa.png";